import React from "react";
import ConfigurationService from "../services/ConfigurationService";
import { ApiClient } from "../services/ApiClient";
import { IQuestionData, QuestionId } from "../shared/multi-language";

export interface IAppContext {
    authenticated: boolean;
    groups: string[];
    config: ConfigurationService;
    api: ApiClient;
    getQuestion: (id: QuestionId) => IQuestionData;
}

const defaultContext: IAppContext = {
    authenticated: false,
    groups: [],
    config: null as any,
    api: null as any,
    getQuestion: null as any,
};
const AppContext = React.createContext(defaultContext);

export default AppContext;
